import { updateUserLocale } from './resources';
import { changeLocale } from './actions';
import { update } from '../../utils/intercom.utils';

// eslint-disable-next-line import/prefer-default-export
export const persistUserLocale = (userId: number, languageId: string) => (dispatch) => {
  update({ language_override: languageId });
  updateUserLocale(userId, languageId)
    .then((response) => {
      // @ts-expect-error TS(2339) Property 'language' | 'dealership' does not exist on type 'unknown'.
      dispatch(changeLocale(`${response.language}-${response.dealership.settings.country}`));
    })
    .catch(() => dispatch(changeLocale('en-CA')));
};
